import { render } from "./DistributorOrderDetail.vue?vue&type=template&id=8d3ca622&scoped=true"
import script from "./DistributorOrderDetail.vue?vue&type=script&lang=js"
export * from "./DistributorOrderDetail.vue?vue&type=script&lang=js"

import "./DistributorOrderDetail.vue?vue&type=style&index=0&id=8d3ca622&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d3ca622"]])

export default __exports__